/* eslint-disable react/jsx-boolean-value */
/* eslint-disable operator-linebreak */
/* eslint-disable indent */
/* eslint-disable jsx-quotes */
/* eslint-disable import/order */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable comma-dangle */
/* eslint-disable quotes */
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Accordion, Button, Card, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import {
  billing_pools,
  billing_rules,
  billing_users,
  calculateTotalCost,
} from '../subscription/utils';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import StripePaymentPopup from '../SubscribePayment/stripePaymentPopup';

const UpadateSubscription = ({
  subscriptionDetails,
  error,
  handleChange,
  userInformation,
  handleClose,
  handleToggleSubscription,
  newUpgradeTotalAmount,
  newPlanUpgrade,
  handleCancel,
}) => {

  const [openPaymentForm, setOpenPaymentForm] = useState(false);
  const [smallLoader, setSmallLoader] = useState(false);
  const [specificDate, setSpecificDate] = useState('');
  const [slectedItem, setSelectedItem] = useState('immediate');
  const [isCalender, setIsCalender] = useState(false);
  const [totalCostForFIlteringProduct, setTotalCostForFIlteringProduct] =
    useState(0);

  const [displayCost, setDisplayCost] = useState(0);
  const [condition, setCondition] = useState(false);


  useEffect(() => {
    const _condition =
      Number(userInformation?.duration) ===
      Number(subscriptionDetails?.duration) &&
      Number(userInformation?.numberOfPools) ===
      Number(subscriptionDetails?.numberOfPools) &&
      Number(userInformation?.numberUsers) ===
      Number(subscriptionDetails?.numberUsers);
    setCondition(_condition);
    setDisplayCost(_condition ? Number(userInformation?.totalCost) : Number(newUpgradeTotalAmount));
  }, [userInformation, subscriptionDetails, newUpgradeTotalAmount])

  const handleSelectChange = (e) => {
    setSelectedItem(e.target.value);
    if (e.target.value === 'specific') {
      setIsCalender(true);
    } else {
      setIsCalender(false);
      setSpecificDate('');
    }
  };
  const handleClick = () => {
    setOpenPaymentForm(true);
  };

  const handleClosePaymentForm = () => {
    setOpenPaymentForm(false);
  };

  const handleFormModal = () => { };

  // Calculate Function for Total Cost for upgrade the Plan
  const findProductPriceId = () => {
    if (subscriptionDetails?.duration && subscriptionDetails?.country && subscriptionDetails?.numberOfPools && subscriptionDetails?.numberUsers) {
      const billingDetails = billing_rules[
        subscriptionDetails.country
      ].find((el) => el.duration === parseInt(subscriptionDetails?.duration));
      const { cost } = billingDetails;
      const productPrice = calculateTotalCost(cost, parseInt(subscriptionDetails?.duration), subscriptionDetails?.numberOfPools, subscriptionDetails?.numberUsers, subscriptionDetails.country);
      setTotalCostForFIlteringProduct(productPrice);
    }
  };

  useEffect(() => {
    if (newUpgradeTotalAmount > 0) {
      findProductPriceId();
    }
  }, [newUpgradeTotalAmount, subscriptionDetails]);

  const handleDateSet = (e) => {
    const inputDate = new Date(e);
    setSpecificDate(inputDate);
    newPlanUpgrade(
      subscriptionDetails?.duration,
      subscriptionDetails?.totalCost,
      subscriptionDetails?.numberOfPools,
      subscriptionDetails?.numberUsers,
      inputDate
    );
    setIsCalender(false);
  };
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    // Combine to get a consistent local date in 'YYYY-MM-DDT00:00:00' format
    const localDateString = `${year}-${month}-${day}`;

    // Convert to UTC without changing the day
    const localDate = new Date(localDateString);
    return localDate.toISOString().split('T')[0];
  };
  return (
    <div className='target-heading new-client-section flex-column'>
      <h1 className='data_heading'>Current Subscription</h1>
      <Accordion className='w-100'>
        <Card.Body>
          <ul className='subscription_billing staff-list top-client-details1 '>
            <li className='staff-list-item'>
              <div className='billing-box'>
                <h3>Subscription Duration</h3>
                <h5>
                  {' '}
                  {console.log('subscriptionDetails?.duration', subscriptionDetails?.duration)}
                  {subscriptionDetails?.duration != 0
                    ? `${subscriptionDetails?.duration} Months`
                    : '10 Day Trial'}
                </h5>
              </div>
            </li>
            <li className='staff-list-item'>
              <div className='billing-box'>
                <h3>Start Date</h3>
                <h5>
                  {' '}
                  {moment(userInformation?.startsubscriptionDate).format(
                    'DD MMM YYYY'
                  )}
                </h5>
              </div>
            </li>
            <li className='staff-list-item'>
              <div className='billing-box'>
                <h3>End Date</h3>
                <h5>
                  {' '}
                  {moment(userInformation?.endsubscriptionDate).format(
                    'DD MMM YYYY'
                  )}
                </h5>
              </div>
            </li>
            <li className='staff-list-item'>
              <div className='billing-box'>
                <h3>No of Pools</h3>
                <h5>{userInformation?.numberOfPools}</h5>
              </div>
            </li>
            <li className='staff-list-item'>
              <div className='billing-box'>
                <h3>No of Users</h3>
                <h5>{userInformation?.numberUsers}</h5>
              </div>
            </li>
            <li className='staff-list-item'>
              <div className='billing-box'>
                <h3>Total Cost</h3>
                <h5>
                  {`${userInformation.country === 'Australia' ? 'AU$' : 'US$'}${userInformation?.subscriptionStatus === 'trial' ? '0' : userInformation.totalCost
                    }`}
                </h5>
              </div>
            </li>
            <div className='staff-form w-100'>
              <div className='row'>
                <div className='col-md-12 detailed-data'>
                  <Form.Group controlId='formBasicLocation'>
                    <Form.Label>Subscription Duration</Form.Label>
                    <div className='select-box'>
                      <Form.Control
                        as='select'
                        name='duration'
                        onChange={(e) => handleChange(e)}
                        value={subscriptionDetails.duration}
                        className={`${error === 'subscriptionduration' ? 'error-text' : ''
                          }`}
                      >
                        <option value=''>Select</option>
                        {billing_rules[subscriptionDetails.country].map(
                          (el) => (
                            <option value={el.duration}>
                              {el.description}
                            </option>
                          )
                        )}
                      </Form.Control>
                    </div>
                  </Form.Group>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 detailed-data'>
                  <Form.Group controlId='formBasicLocation'>
                    <Form.Label>No. of Pools</Form.Label>
                    <div className='select-box'>
                      <Form.Control
                        as='select'
                        value={subscriptionDetails.numberOfPools}
                        name='numberOfPools'
                        onChange={(e) => handleChange(e)}
                        className={`${error === 'numberofpools' ? 'error-text' : ''
                          }`}
                        disabled={
                          subscriptionDetails?.duration === 0 ||
                          subscriptionDetails?.duration === '0'
                        }
                      >
                        <option value=''>Select</option>
                        {billing_pools[subscriptionDetails.country].map(
                          (el) => (
                            <option value={el.num}>{el.description}</option>
                          )
                        )}
                      </Form.Control>
                    </div>
                  </Form.Group>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 detailed-data'>
                  <Form.Group controlId='formBasicLocation'>
                    <Form.Label>No. of Users</Form.Label>
                    <div className='select-box'>
                      <Form.Control
                        as='select'
                        value={subscriptionDetails.numberUsers}
                        name='numberUsers'
                        onChange={(e) => handleChange(e)}
                        className={`${error === 'numberofuser' ? 'error-text' : ''
                          }`}
                        disabled={
                          subscriptionDetails?.duration === 0 ||
                          subscriptionDetails?.duration === '0'
                        }
                      >
                        <option value=''>Select</option>
                        {billing_users[subscriptionDetails.country].map(
                          (el) => (
                            <option value={el.num}>{el.description}</option>
                          )
                        )}
                      </Form.Control>
                    </div>
                  </Form.Group>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 detailed-data'>
                  <Form.Group controlId='formBasicLocation'>
                    <Form.Label>Update Subscription Effective From</Form.Label>
                    <div className='select-box'>
                      <Form.Control
                        as='select'
                        name='dropdown'
                        value={slectedItem}
                        onChange={handleSelectChange}
                        disabled={
                          subscriptionDetails?.duration === 0 ||
                          subscriptionDetails?.duration === '0'
                        }
                      >
                        <option value='immediate'>Update Immediately</option>
                        <option value='specific'>
                          Update From Specific Date
                        </option>
                        <option value='endOfperiod'>
                          Update at End of Current Subscription
                        </option>
                      </Form.Control>
                    </div>
                  </Form.Group>
                </div>
              </div>
              {specificDate && <div>{formatDate(specificDate)}</div>}
              <div className='row'>
                <div className='col-md-12 detailed-data'>
                  <Form.Group controlId='formBasicLocation' className='m-0'>
                    <Form.Label>
                      Total Cost:
                      {`${userInformation?.country === 'Australia' ? 'AU' : 'US'} $${userInformation?.subscriptionStatus === 'trial' && condition ? '0.00' : displayCost.toFixed(2)}`}

                      {/* {`${userInformation?.country === 'Australia' ? 'AU' : 'US'
                        } $${displayCost.toFixed(2)}`}{' '} */}

                    </Form.Label>
                  </Form.Group>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='view-btn staff-form-btn'>
                    <Button
                      type='button'
                      className='btn btn-edit'
                      onClick={handleCancel}
                    >
                      {' '}
                      Cancel{' '}
                    </Button>
                    <Button
                      type='Submit'
                      className='btn btn-save'
                      onClick={handleClick}
                      disabled={condition}
                    >
                      {' '}
                      Next{' '}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </ul>
        </Card.Body>
      </Accordion>
      {isCalender && (
        <div className='search-popup shift-container'>
          <div className='time-calender'>
            <Calendar onChange={handleDateSet} value={specificDate}
              minDate={new Date(userInformation?.startsubscriptionDate)} // Minimum selectable date
            />
          </div>
        </div>
      )}
      {openPaymentForm ? (
        <StripePaymentPopup
          openPaymentForm={openPaymentForm}
          clientData={subscriptionDetails}
          handleAction={handleClosePaymentForm}
          smallLoader={smallLoader}
          returnPopUp='subscriptionPage'
          handleFormModal={handleFormModal}
          UpdateSubscriptionPopup={true}
          updateSubscriptionTotalCostValue={newUpgradeTotalAmount}
          totalCostForFIlteringProduct={totalCostForFIlteringProduct}
          slectedItem={slectedItem}
          handleToggleSubscription={handleToggleSubscription}
          specificDate={specificDate}
        />
      ) : null}
    </div>
  );
};
export default UpadateSubscription;

UpadateSubscription.propTypes = {
  userInformation: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired,
  subscriptionDetails: PropTypes.objectOf({}).isRequired,
};
